import HelmetLayout from "../../components/GlobalComponents/HelmetLayout";
import Banner from "../../components/MechanicalWorks/Banner/Banner";
import Benefits from "../../components/MechanicalWorks/Benefits/Benefits";
import Cards from "../../components/MechanicalWorks/Cards/Cards";
import List from "../../components/MechanicalWorks/List/List";
import Conditioning from "../../components/MechanicalWorks/Conditioning/Conditioning";
import Steps from "../../components/MechanicalWorks/Steps/Steps";

const MechanicalWorks = () => {
    return (
        <HelmetLayout
            name="Mechanical Works"
            title="Ard Altaamir: Mechanical Works & Maintenance"
            description="Ard Altaamir offers professional mechanical works and maintenance for residential and commercial systems. Reliable and cost-effective service."
            route="services/mechanical-works"
        >
            <Banner />
            <List />
            <Conditioning />
            <Steps />
            <Benefits />
            <Cards />
        </HelmetLayout>
    );
};

export default MechanicalWorks;
